module.exports = __webpack_public_path__ + "static/media/Cup_cup.097b9a4b.png";